import React from "react";
import { ClubsProvider } from "../../../contexts/Clubs";
import { OrganizersProvider } from "../../../contexts/Organizers";
import { ClubContainer } from "../../components/clubs/ClubContainer";

import Header, { pages } from "../Header";

export const ClubPage = () => {
    return (
        <ClubsProvider>
            <OrganizersProvider>
                <Header activePage={pages.CLUBS} />
                <ClubContainer/>
            </OrganizersProvider>
        </ClubsProvider>
    );
};